import { createFileRoute } from "@tanstack/react-router";
import { Heute } from "../features/shell/Heute";

export const Route = createFileRoute("/")({
  component: Heute,
});
